










































































































































































import { defineComponent, toRefs, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { ChevronDownIcon } from 'tdesign-icons-vue';
import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';

import { SearchLogItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';
import listHandler from './compositions/listHandler';
import ListDrawer from './components/listDrawer.vue';
export default defineComponent({
  components: {
    ChevronDownIcon,
    ListDrawer,
    SelectAnySpaceTargetFolder,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const {
      spaceOptions,
      actionList,
      columns,
      tableData,
      loadingStatus,
      disabledDate,
      timeRange,
      conditions,
      localTransferList,
      showExportingMsg,
      isAdminOrSuperAdmin,
      methods: listMethods,
    } = listHandler();

    const resizeColumns = ref(setResizableColumns(columns));

    const { loading, list, hasMore } = toRefs(tableData);
    const hasSearched = ref(false);
    const logExporting = computed(() => store.getters.logExporting);
    const showListDrawer = ref(false);
    const showSelectTargetFolder = ref(false);
    const methods = {
      query() {
        // 简单校验表单
        if (!conditions.spaceTag) {
          tips.error(i18n_t('请选择所属位置'));
          return;
        }
        hasSearched.value = true;
        listMethods.startSearch();
      },
      reset() {
        listMethods.initConditions();
      },
      exportLog() {
        reporter.report('export_all_logs');
        // 导出当前列表
        listMethods.exportList();
        // 全量导出暂时屏蔽
        // listMethods.exportAll();
      },

      onClickExport2Cloud() {
        // 简单校验表单
        if (!conditions.spaceTag) {
          tips.error(i18n_t('请选择所属位置'));
          return;
        }
        showSelectTargetFolder.value = true;
      },
      export2Cloud(params: { spaceId: string; dirPath: string }) {
        showSelectTargetFolder.value = false;
        listMethods.export2Cloud(params.spaceId, params.dirPath);
        reporter.report('export_all_logs');
      },
      getOperatorPhoneNumber(item: SearchLogItem) {
        let phone = store.getters.allowPhoneLogin ? i18n_t('暂未绑定') : '';
        if (item.attachInfo.operatorPhoneNumber) {
          phone = item.attachInfo.operatorPhoneNumber;
        } else if (item.operatorPhoneNumber) {
          phone = item.operatorPhoneNumber;
        }
        return phone ? `（${phone}）` : '';
      },
    };
    return {
      spaceOptions,
      resizeColumns,
      actionList,
      disabledDate,
      timeRange,
      loading,
      list,
      hasMore,
      logExporting,
      hasSearched,
      loadingStatus,
      listMethods,
      showListDrawer,
      showSelectTargetFolder,
      localTransferList,
      showExportingMsg,
      isAdminOrSuperAdmin,
      ...toRefs(conditions),
      ...methods,
    };
  },
});
